import {useState, createContext} from 'react'

export const GlobalContext = createContext(false)

export const GlobalProvider = ({children}) => {
  const [darkMode, setDarkMode] = useState(false)

  return (
    <GlobalContext.Provider
      value={{
        darkMode,
        setDarkMode,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}
